import React, { MouseEventHandler } from 'react'
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

import './style.scss';

interface IBindingButtonProps {
  disabled?: boolean,
  isLoading?: boolean;
  onClickHandler?: MouseEventHandler;
  title: string;
}

function BindingButton(props: IBindingButtonProps) {
  const {
    disabled = false,
    isLoading = false,
    onClickHandler,
    title
  } = props;

  return (
    <Button
      className="BindingButton"
      disabled={disabled || isLoading || !Boolean(onClickHandler)}
      onClick={onClickHandler}
      size="sm"
      variant="custom"
    >
      { isLoading ?
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
        : title
      }
    </Button>
  );
}

export default BindingButton;
